export default __webpack_public_path__ + "static/media/franklyn-logo.b9a686e3.png";